export default __webpack_public_path__ + "static/media/nft.360abf7b.png";